import { Component, OnInit, ViewChild } from '@angular/core';
import { EngagementModel } from '../../../models/engagement.model';
import { environment } from '../../../../environments/environment';
import { EngagementService } from '../../../services/engagement.service';
import { UserService } from './../../../services/user.service';
import { Table } from 'primeng/table';
import { UserModel } from '../../../models/user.model';
import { MessageService } from 'primeng/api';
import { severitymessage, EngagementDetailMessage, LanguageConstants } from '../../../shared-components/constant';
import { InfraService } from 'src/app/services/infra.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-reactivate-engagement',
  templateUrl: './reactivate-engagement.component.html',
  styleUrls: ['./reactivate-engagement.component.css']
})
export class ReactivateEngagementComponent implements OnInit {
  engagements: EngagementModel[];
  cols: any[];
  
  @ViewChild('dt', { static: true }) private _table: Table;

  public pagerows: number;
  private loggedInId: number;
  private regionName: string;
  private selectedregion: number;
  langCode: string;
  currLangTranslation: any;
  constructor(private infraService: InfraService, private engagementService: EngagementService
    , private userService: UserService, private messageService: MessageService, private translateService: TranslateService) {
    this.infraService.infraDetails$.subscribe(data => {
      this.selectedregion = data.InfraId;
      this.regionName = data.RegionName;
    });
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
    this.messageService.clear('myKey1');
    this.pagerows = environment.pageRows25;
    this.cols = [
      { field: 'Status', header: 'Status', visible: true, isEditable: false, styleClass: 'er-status' },
      { field: 'Id', header: 'Engagement ID', visible: true, isEditable: false, styleClass: 'er-engagement-id' },
      { field: 'EngagementName', header: 'Project name', visible: true, isEditable: false, styleClass: 'er-engagement-name' },
      { field: 'CountryName', header: 'Country', visible: true, isEditable: false, styleClass: 'er-country' },
      { field: 'CountryCode', header: 'Country', visible: false, isEditable: false },
      { field: 'AccountCalendar', header: 'Accounting calendar', visible: true, isEditable: false, styleClass: 'er-account-calendar' },
      { field: 'Users', header: 'Project team', visible: true, isEditable: false, styleClass: 'er-engagement-team' },
      { field: 'Action', header: 'Action', visible: true, isEditable: false},
    ];

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInId = userData.Id;
        this.getClosedEngagements();
      }
    });
  }

  private getClosedEngagements(): void {
    if (this.loggedInId) {
      this.engagementService.getClosedEngagements(this.regionName)
        .subscribe((data: EngagementModel[]) => {
          this.engagements = data;
          this.engagements.map((resp) => {
            if (resp.ReportingCurrencyName) {
              resp.ReportingCurrencyName = resp.ReportingCurrencyName + ' ' + '(' + resp.CurrencySymbol + ')';
            } else {
              resp.ReportingCurrencyName = '';
            }
          });
        }, error => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error
            , summary: this.currLangTranslation.severitymessage.notification, detail: error.error.message, sticky: true, closable: true
          });
      });
    }
  }

  reactivateEngagement(engagement: EngagementModel) {    
    this.engagementService.reactivateClosedEngagement(engagement.Id).subscribe((response: any) =>{
      if(response.message){
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.engagementDetailMessage.SuccessMessage.Reactivated, sticky: true, closable: true
        });
        this.getClosedEngagements();
      }
      else{
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      }
    },
      error => {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error
          , summary: this.currLangTranslation.severitymessage.notification, detail: error.error.message, sticky: true, closable: true
        });
      });    
  }
 
  public getCountryFlagClassName(engagement) {
    if (engagement.CountryCode !== undefined && engagement.CountryCode !== null) {
      return 'flag-icon-' + engagement.CountryCode.toLowerCase();
    }
    return '';
  }

  public getClass(data: any) {
    let returnVal = 'ec-default';
    if (data) {
      returnVal = data.styleClass;
    }
    return returnVal;
  }
}
